import ModalDialog from './modal-dialog';

const selectors = {
  regionsModalTrigger: '[data-modal-region-trigger]',
  regionsModal: '[data-modal-region]',
};

export default function initRegionModal() {
  const regionsModalTrigger = document.querySelectorAll(selectors.regionsModalTrigger);
  const regionsModalElem = document.querySelector(selectors.regionsModal);

  if (regionsModalTrigger.length > 0 && regionsModalElem) {
    // eslint-disable-next-line no-unused-vars
    const regionsModal = new ModalDialog(regionsModalElem, {
      triggerEl: regionsModalTrigger,
      modalId: 'region',
    });
  }
}
